export default "__VITE_ASSET__DcKVmkQ8__"